import React from 'react';

import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

import { Drawer } from 'antd';

import PlaceHeader from './Components/header';
import MainButton from './Components/mainButton';
import PlaceImageGallery from './Components/imageGallery';
import PlaceDescription from './Components/description';
import PlacePoint from './Components/point';
import SavePlace from './Components/save';

const PlaceContent = (props) => {
  return (
    <div className="tourContent place">
      <div className="mainInfo">
        <PlaceHeader {...props} />
        <MainButton {...props} />
        <PlaceImageGallery {...props} />
        <PlaceDescription {...props} />
        <PlacePoint {...props} />
      </div>
      <SavePlace {...props} />
    </div>
  );
};

const PlacesView = (props) => {
  const prop = { ...props };
  return (
    <>
      <Drawer
        getContainer={false}
        title={false}
        placement="left"
        mask={false}
        closable
        visible
        width="100%"
        style={{ height: 1 }}
        className="createTourContainer createTour"
        onClose={() => props.handleClose()}
        zIndex={501}
        keyboard={false}
      >
        <div className="tourLayout" aria-hidden="true">
          <PlaceContent {...prop} />
        </div>
      </Drawer>
      <div
        style={{
          width: '100%',
          height: 1,
          position: 'relative',
          zIndex: 500,
        }}
      />
    </>
  );
};

export default PlacesView;
